@if (inputType == inputTypeEnum.Approval) {
	<div class="approval-button-row">
		<div class="button" (click)="approvalStatus = approvalStatusEnum.Approved" [ngClass]="{action: approval == undefined, confirm: approvalStatus == approvalStatusEnum.Approved, disabled: approvalStatus == approvalStatusEnum.Rejected}">{{ 'general.approved' | translate }}</div>
		<div class="button" (click)="approvalStatus = approvalStatusEnum.Rejected" [ngClass]="{action: approval == undefined, reject: approvalStatus == approvalStatusEnum.Rejected, disabled: approvalStatus == approvalStatusEnum.Approved}">{{ 'general.rejected' | translate }}</div>
	</div>
}

@if (inputType != inputTypeEnum.Approval || (inputType == inputTypeEnum.Approval && showTextarea())) {
	<div class="custom-input" [ngClass]="specialBehaviorClass" #container>
		@if (inputType == inputTypeEnum.Switch) {
			<mat-slide-toggle
				#input
				hideIcon
				[labelPosition]="labelPosition"
				[(ngModel)]="checkboxValue"
				(ngModelChange)="valueChanged()"
				(click)="$event.stopPropagation()"
				[required]="required"
				[disabled]="disabled"
				type="checkbox"
				[class]="class"
				[ngClass]="{ switch: true }">{{label}}</mat-slide-toggle>
		}
		@if (inputType == inputTypeEnum.Checkbox) {
			<mat-checkbox
				#input
				[labelPosition]="labelPosition"
				[(ngModel)]="checkboxValue"
				(ngModelChange)="valueChanged()"
				(click)="$event.stopPropagation()"
				[required]="required"
				[disabled]="disabled"
				type="checkbox"
				[class]="class">{{label}}</mat-checkbox>
		}
		@if (inputType == inputTypeEnum.Radio) {
			<mat-radio-group
				#input
				[labelPosition]="labelPosition"
				(change)="value = $event.value; valueChanged()"
				[required]="required"
				[disabled]="disabled"
				[class]="class"
				[class.vertical]="vertical"
				aria-label="{{ label }}">
				@for (button of radioButtons; track button) {
					<mat-radio-button [value]="button.value" [checked]="button.value === value">{{ button.label }}</mat-radio-button>
				}
			</mat-radio-group>
		}
		@if ((inputType == inputTypeEnum.Text && !showTextarea()) || inputType == inputTypeEnum.Currency || inputType == inputTypeEnum.Number || inputType == inputTypeEnum.Percentage) {
			<mat-form-field [ngClass]="{ 'has-hint' : hint, 'has-validation-message': validationMessage }">
				@if (label || required) {
					<mat-label>{{ label }}</mat-label>
				}
				@if (prefix) {
					<div matTextPrefix>{{ prefix }}</div>
				}
				<input #input
					matInput
					type="text"
					[pattern]="allowedPattern"
					[ngStyle]="{ 'text-align': textAlign }"
					[(ngModel)]="displayValue"
					[class]="class"
					(blur)="onBlur()"
					(ngModelChange)="valueChanged()"
					(focus)="editValue()"
					(keyup.enter)="setBlur()"
					(keydown)="validateKeyInput($event)"
					(paste)="validatePasteInput($event)"
					[placeholder]="placeholder"
					[customValidState]="customValidState"
					[validation]="validation"
					[required]="required"
					[disabled]="disabled"
					(validationStateChange)="valid = $event"
					[ignoreFormValidation]="ignoreFormValidation"
					autocompleteOff
					[maxlength]="maxlength" />
				
				@if (suffix) {
					<div matTextSuffix>{{ suffix }}</div>
				}
				@if (validationMessage) {
					<mat-error>{{ customValidState === false ? customValidationMessage : ('validation.' + validationMessage | translate) }}</mat-error>
				}
				@if (hint) {
					<mat-hint>{{ hint }}</mat-hint>
				}
			</mat-form-field>
		}
		@if (showTextarea()) {
			<mat-form-field floatLabel="always">
				@if (label || required) {
					<mat-label>{{ label }}</mat-label>
				}
				<textarea #input
					matInput
					autosize (resized)="onResized()"
					[htmlEditor]="inputType == inputTypeEnum.Editor"
					[ngStyle]="{ 'text-align': textAlign }"
					[(ngModel)]="displayValue"
					[class]="class"
					[class.small]="multiLine"
					(blur)="onBlur()"
					(ngModelChange)="valueChanged()"
					(focus)="editValue()"
					(keydown)="validateKeyInput($event)"
					(paste)="validatePasteInput($event)"
					[placeholder]="placeholder"
					[validation]="validation"
					[required]="required"
					[disabled]="disabled"
					[customValidState]="customValidState"
					(validationStateChange)="valid = $event"
					[ignoreFormValidation]="ignoreFormValidation"
					[maxlength]="maxlength"></textarea>
				@if (validationMessage) {
					<mat-error>{{ 'validation.' + validationMessage | translate }}</mat-error>
				}
			</mat-form-field>
		}
		<ng-content />
	</div>
}
